import { Component, inject } from '@angular/core';
import { Auth } from '../../services/auth';

@Component({
  selector: 'app-user',
  imports: [],
  templateUrl: './user.html',
  styleUrl: './user.css',
})
export class User {
  private readonly auth = inject(Auth);
  protected email = this.auth.getEmail();
  protected token = this.auth.getAccessToken();
}
